import React, { useRef, useEffect } from "react";
import { VisuallyHidden } from "../VisuallyHidden/VisuallyHidden";

export const CustomFormAlert = ({
  errors,
  isSubmitting,
  submitCount,
  message,
  testId = 'CustomFormAlert',
}: {
  errors: any;
  isSubmitting: boolean;
  submitCount: number;
  message: string;
  testId?: string;
}) => {
  const hasSubmitted = useRef(false);

  useEffect(() => {
    if (submitCount > 0) {
      hasSubmitted.current = true;
    }

    if (Object.keys(errors).length === 0) {
      hasSubmitted.current = false;
    }
  }, [submitCount, errors]);

  const shouldShowErrorMessage =
    hasSubmitted.current && !isSubmitting && Object.keys(errors).length > 0;

  return shouldShowErrorMessage ? (
    <VisuallyHidden>
      <div aria-live="assertive" role="alert" data-testid={testId}>
        {message}
      </div>
    </VisuallyHidden>
  ) : null;
};
